import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import { Box } from '../../Common/BoxV2';

export const Nothing = (props: RenderElementProps) => {
  const { attributes, children } = props;
  return (
    <Box display="none" {...attributes}>
      {children}
    </Box>
  );
};
